import { createUseStyles } from 'react-jss';
import { MD_MEDIA_QUERY } from '~shared/media-query';
import { PricingAppTheme } from '~app/styles/theme';

export default createUseStyles(({ spacing, type, pricingPalette }: PricingAppTheme) => ({
  Container: {
    margin: [0, 'auto', spacing[5]],
    [MD_MEDIA_QUERY]: {
      marginBottom: spacing[7],
    },
  },
  List: {
    display: 'flex',
    listStyle: 'none',
    justifyContent: 'center',
    padding: 0,
  },
  ListItem: {
    padding: '0.6em 0.8em 0.6em 0.6em',
    margin: [0, 12],
    fontSize: type.fontSize.bodySm,
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    [MD_MEDIA_QUERY]: {
      fontSize: type.fontSize.body,
    },
    '& a': {
      color: pricingPalette.colors.charcoal,
      '&:hover, &:focus': {
        textDecoration: 'none',
      },
    },
    '&.selected': {
      borderBottom: `3px solid ${pricingPalette.colors.sabaeus}`,
      '& a': {
        color: pricingPalette.colors.sabaeus,
      },
    },
  },
}));
